import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DirectivesModule } from '@freelancer/directives';
import { trackByValue } from '@freelancer/ui/helpers';
import { LoadingTemplateComponent } from '@freelancer/ui/loading-template';

@Component({
  standalone: true,
  imports: [DirectivesModule, NgTemplateOutlet, LoadingTemplateComponent],
  selector: 'fl-loading-text',
  template: `
    <ng-template
      #rows
      let-arr
    >
      @if (arr.length > 0) {
        @for (row of arr; track trackByValue($index, row)) {
          <fl-loading-template class="Row-text" />
        }
      } @else {
        <fl-loading-template class="Row" />
      }
    </ng-template>

    @if (mobileRows !== undefined) {
      <div class="MobileOnly Rows">
        <ng-container
          *ngTemplateOutlet="rows; context: { $implicit: mobileRowsArray }"
        />
      </div>
      <div class="DesktopOnly Rows">
        <ng-container
          *ngTemplateOutlet="rows; context: { $implicit: rowsArray }"
        />
      </div>
    } @else {
      <div class="Rows">
        <ng-container
          *ngTemplateOutlet="rows; context: { $implicit: rowsArray }"
        />
      </div>
    }
  `,
  styleUrls: ['./loading-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingTextComponent {
  trackByValue = trackByValue;

  /** Number of rows of loading text to display.*/
  @Input() rows?: number;

  /** Number of rows of loading text to display on mobile screens.*/
  @Input() mobileRows?: number;

  get rowsArray(): number[] {
    const count = this.rows ?? 0;
    return Array.from({ length: count }, (_, i) => i);
  }

  get mobileRowsArray(): number[] {
    return Array.from({ length: this.mobileRows ?? 0 }, (_, i) => i);
  }
}
